/**
 * OPARA v7.0 - Language Configuration
 * Supported languages and their configurations
 */

export const SUPPORTED_LANGUAGES = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    dir: 'ltr',
    status: 'master', // master = production ready
    noindex: false
  },
  tr: {
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe',
    flag: '🇹🇷',
    dir: 'ltr',
    status: 'production', // production = live Turkish operation
    noindex: false
  },
  fr: {
    code: 'fr',
    name: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    dir: 'ltr',
    status: 'production', // v7.2 - Full i18n complete
    noindex: false
  },
  de: {
    code: 'de',
    name: 'German',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    dir: 'ltr',
    status: 'production', // v7.2 - Full i18n complete
    noindex: false
  },
  es: {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    dir: 'ltr',
    status: 'production', // v7.2 - Full i18n complete
    noindex: false
  },
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    flag: '🇸🇦',
    dir: 'rtl', // Right-to-left
    status: 'production', // Now live with full routing
    noindex: false
  }
};

export const DEFAULT_LANGUAGE = 'en';
export const STORAGE_KEY = 'opara_language';

/**
 * Get user's preferred language from localStorage
 */
export const getStoredLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(STORAGE_KEY);
  }
  return null;
};

/**
 * Store user's language preference
 */
export const setStoredLanguage = (langCode) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, langCode);
  }
};

/**
 * Check if user has already selected a language
 */
export const hasLanguagePreference = () => {
  return !!getStoredLanguage();
};

/**
 * Get language config by code
 */
export const getLanguageConfig = (code) => {
  return SUPPORTED_LANGUAGES[code] || SUPPORTED_LANGUAGES[DEFAULT_LANGUAGE];
};

/**
 * Get current language from URL path
 */
export const getLanguageFromPath = (pathname) => {
  const match = pathname.match(/^\/(en|tr|fr|de|es|ar)(\/|$)/);
  if (match) {
    return match[1];
  }
  // Root path without language prefix defaults to stored preference or 'en'
  return getStoredLanguage() || DEFAULT_LANGUAGE;
};
